import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:3001/api/v1";
const API_KEY  = process.env.REACT_APP_API_KEY || "";

const api = axios.create({ baseURL: API_BASE, headers: { "api-key": API_KEY } });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("jury_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let _redirecting = false;

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !_redirecting) {
      _redirecting = true;
      localStorage.removeItem("jury_token");
      localStorage.removeItem("jury_user");
      localStorage.removeItem("jury_role");
      import("react-toastify").then(({ toast }) => {
        toast.error("Your session has expired. Please sign in again.", { toastId: "session-expired" });
      });
      setTimeout(() => { window.location.href = "/login"; }, 1800);
    }
    return Promise.reject(err);
  }
);

export default api;
